import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { fetchAllLifecycleStages } from 'src/models/lifecycle/lifecycle';

interface LifecycleStageFilterProps {
  value: string;
  setValue: (value: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
}

export const LifecycleStageFilter = ({
  value,
  setValue,
  valueOnly,
  multiple = false,
}: LifecycleStageFilterProps) => {
  const { data: stages } = useQuery({
    queryKey: ['lifecycleStages'],
    queryFn: fetchAllLifecycleStages,
    staleTime: 60000,
    gcTime: 60000,
  });

  const stageIds = value ? String(value).split(',') : [];

  if (valueOnly) {
    return (
      <>
        {stageIds
          ?.map((v) => stages?.find((s) => String(s.id) == v)?.name)
          ?.join(', ')}
      </>
    );
  }

  return (
    <Autocomplete
      size="small"
      multiple={multiple}
      value={
        multiple
          ? stages?.filter((s) => stageIds?.includes(String(s.id))) || []
          : stages?.find((s) => stageIds?.includes(String(s.id))) || null
      }
      onChange={(_, newValue) => {
        if (multiple) {
          setValue((newValue as any[]).map((v) => String(v.id)).join(','));
        } else {
          setValue(String(newValue?.id || ''));
        }
      }}
      options={stages || []}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField {...params} label="Lifecycle Stage" size="small" />
      )}
    />
  );
};
